module.exports = __webpack_public_path__ + "img/meeting_and_events_blue.529e2537.svg";